import { render } from "./LoaderComponent.vue?vue&type=template&id=c6602f78&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=c6602f78&scoped=true&lang=css"

import exportComponent from "/agent/_work/1/s/GiftCards/giftcard_vuejs_src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6602f78"]])

export default __exports__